/**
 * 常用的一些方法
 *
*/

import deepmerge from "deepmerge";
import store from "@/store";

export const formatTimeStr = (timeStr)=>{
  if(!timeStr){
    timeStr = new Date();
  }

  let dataStr = new Date(timeStr);
  let year = dataStr.getFullYear();
  let month = dataStr.getMonth() + 1;
  month = month < 10 ? "0" + month : month;

  let day = dataStr.getDate();
  day = day < 10 ? "0" + day : day;

  let hour = dataStr.getHours();
  hour = hour < 10 ? "0" + hour : hour;

  let min = dataStr.getMinutes();
  min = min < 10 ? "0" + min : min;

  let sec = dataStr.getSeconds();
  sec = sec < 10 ? "0" + sec : sec;

  let str = year + "-" + month + "-" + day + " " + hour + ":" + min + ":" + sec;

  return str;
}

const isPlainObject = (obj)=>{
  return Object.prototype.toString.call(obj) === "[object Object]";
}

export const deepMerge = (...args)=>{
  if(args.length > 2){
    return deepmerge.all(args);
  }
  else{
    return deepmerge(args[0],args[1]);
  }
}

// 防抖
export const debounce = function(fn, wait){
  let timer = null;
  return function () {
    let self = this;
    if(timer) clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(self, arguments)   // 把参数传进去
    }, wait);
  }
}


export const getQueryString = (name) => {
  let url = window.location.href;
  let urlStr = url.split('?')[1];

  if(urlStr){
    let obj = {};
    // 再通过 & 将每一个参数单独分割出来
    let paramsArr = urlStr.split('&')
    for(let i = 0,len = paramsArr.length;i < len;i++){
        // 再通过 = 将每一个参数分割为 key:value 的形式
        let arr = paramsArr[i].split('=')
        obj[arr[0]] = arr[1];
    }
    // 创建空对象存储参数
    return obj[name]
  }

  return "";
}


// 校验邮箱格式
export const validateEmail = (email)=>{
	let regExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // 定义邮箱格式的正则表达式

	return regExp.test(email); // 返回true或false，判断输入的邮箱是否符合规则
}


export const showDateString = (timeStr) => {
  let lang = store.state.lang;
	if(!timeStr){
		timeStr = new Date();
	}

	let curDate = new Date(timeStr);
	let forDateStr = formatTimeStr(curDate);
	let curDateTime = curDate.getTime();


	let now = formatTimeStr();
	let todayDate = now.substring(0, 10);
	let todayStart = new Date(todayDate + " " + "00:00:00").getTime();
	let todayEnd = new Date(todayDate + " " + "23:59:59").getTime();
	let oneDayMilSeconds = 24*60*60*1000;

	let yesterdayStart = new Date(todayStart).getTime() - oneDayMilSeconds;
	let yesterdayEnd = new Date(todayEnd).getTime() - oneDayMilSeconds;

	let last2dayStart = new Date(todayStart).getTime() - oneDayMilSeconds*2;
	let last2dayEnd = new Date(todayEnd).getTime() - oneDayMilSeconds*2;

	let last3dayStart = new Date(todayStart).getTime() - oneDayMilSeconds*3;
	let last3dayEnd = new Date(todayEnd).getTime() - oneDayMilSeconds*3;

	if(curDateTime >= todayStart && todayEnd >= curDateTime){
		return forDateStr.substring(11,16);
	}
	else if(curDateTime >= yesterdayStart && yesterdayEnd >= curDateTime){
		return lang == "en"?"Yesterday":"昨天";
	}
	else if(curDateTime >= last2dayStart && last2dayEnd >= curDateTime){
		return lang == "en"?"2 days ago":"前天";
	}
	else if(curDateTime >= last3dayStart && curDateTime >= last3dayEnd){
		return lang == "en"?"3 days ago":"3天前";
	}
	else if(curDateTime < last3dayStart){
		return forDateStr.substring(5,10);
	}
}

export const showDateAndTimeString = (timeStr) => {
	if(!timeStr){
		timeStr = new Date();
	}

	let curDate = new Date(timeStr);
	let forDateStr = formatTimeStr(curDate);
	let curDateTime = curDate.getTime();


	let now = formatTimeStr();
	let todayDate = now.substring(0, 10);
	let todayStart = new Date(todayDate + " " + "00:00:00").getTime();
	let todayEnd = new Date(todayDate + " " + "23:59:59").getTime();
	let oneDayMilSeconds = 24*60*60*1000;

	let yesterdayStart = new Date(todayStart).getTime() - oneDayMilSeconds;
	let yesterdayEnd = new Date(todayEnd).getTime() - oneDayMilSeconds;

	let last2dayStart = new Date(todayStart).getTime() - oneDayMilSeconds*2;
	let last2dayEnd = new Date(todayEnd).getTime() - oneDayMilSeconds*2;

	let last3dayStart = new Date(todayStart).getTime() - oneDayMilSeconds*3;
	let last3dayEnd = new Date(todayEnd).getTime() - oneDayMilSeconds*3;

	if(curDateTime >= todayStart && todayEnd >= curDateTime){
		return forDateStr.substring(11,16);
	}
	else{
		return forDateStr.substring(5,16);
	}
}



export const getQueryParams = (url) => {
	const queryString = url.split('?')[1]; // 获取查询字符串部分
	const params = {};
	if (queryString) {
	  queryString.split('&').forEach(param => {
		const [key, value] = param.split('=');
		params[key] = value ? decodeURIComponent(value) : '';
	  });
	}
	return params;
  }